import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createCashTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, TableRowAction.Edit) },
      { label: 'Ingreso desde banco', icon: 'move_to_inbox', callback: (row) => handleAction(row, TableRowAction.IngresoBanco) },
      { label: 'Reintegro del socio', icon: 'remove_circle_outline', callback: (row) => handleAction(row, TableRowAction.RetiroSocio) },
      { label: 'Ingreso del socio', icon: 'person_add', callback: (row) => handleAction(row, TableRowAction.IngresoSocio) },
      {
        label: 'Mayor contable',
        icon: 'title',
        visible: (row) => !!row && !!row.accountingModelsNumber,
        callback: (row) => handleAction(row, TableRowAction.Ledger),
      },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, TableRowAction.Delete) },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || '',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  IngresoBanco = 'ingresoBanco',
  RetiroSocio = 'retiroSocio',
  IngresoSocio = 'ingresoSocio',
  Ledger = 'ledger',
}
